import styled from 'styled-components';
import { darken } from 'polished';

export const FooterWrapper = styled.footer`
    max-width:1080px;
    margin: 0 auto;   
    display: flex;
    justify-content: space-between;
    padding: 0 0 40px 0;
    div {
        display: flex;
        align-items: center;
        
        &:nth-child(2) {
            a {
                padding-left: 20px;
                color: var(--blue);
                transition: 0.3s;

                &:hover {
                    color: ${darken(0.3, '#38418e')}
                }
            }
        }
        
        img {
            width: 100px;
        }
        ul {
            display:flex;
            li {
                display:flex;
                align-items: center;
                color: var(--gray);
                padding-left: 20px;

                p {
                    margin-left: 5px;
                }
            }
        }
    }

    @media (max-width: 1100px) {
        width: 80%;
    }

    @media (max-width: 900px) {
        width: 80%;
        max-width:1080px;
        margin: 0 auto;   
        display: block;
        justify-content: space-between;
        padding: 0 0 40px 0;
        div {
        display: flex;
        align-items: center;
        
        &:nth-child(2) {
            a {
                /* width: 20px; */
                color: var(--blue);
                transition: 0.3s;
                padding: 0px;
                &:nth-child(1n+2) {
                    padding: 15px 0px 15px 15px; 
                }

                &:hover {
                    color: ${darken(0.3, '#38418e')}
                }
            }
        }
        
        img {
            width: 100px;
        }
            ul {
                display:flex;
                li {
                    display:flex;
                    align-items: center;
                    color: var(--gray);
                    padding-left: 20px;

                    p {
                        margin-left: 5px;
                    }
                }
            }
        }
    }


    @media (max-width: 755px) {
        width: 80%;
        max-width:1080px;
        margin: 0 auto;   
        display: block;
        justify-content: space-between;
        padding: 0 0 40px 0;
        div {
        display: block;
        align-items: center;
        
        &:nth-child(2) {
            a {
                color: var(--blue);
                transition: 0.3s;
                padding: 0px;
                &:nth-child(1n+2) {
                    padding: 15px 0px 15px 15px; 
                }

                &:hover {
                    color: ${darken(0.3, '#38418e')}
                }
            }
        }
        
        img {
            width: 100px;
        }
        ul {
            display:flex;
            li {
                display:flex;
                align-items: center;
                color: var(--gray);
                padding: 0;
                    &:nth-child(1n+2) {
                        padding: 15px 0 15px 15px;

                    }

                    p {
                        margin-left: 5px;
                    }
                }
            }
        }
    }

    @media (max-width: 600px) {  
        div{
            ul {
                display:block;
            li {
                display:flex;
                align-items: center;
                color: var(--gray);
                padding: 0;

                    &:nth-child(1n+2) {
                        padding: 5px 0 5px 0;
                    }

                    p {
                        margin-left: 5px;
                    }
                }
            }
        }
    }    
`;
